<template>
  <button
    type="button"
    :disabled="disabled"
    class="tax-button"
    :class="'tax-button--' + state"
    :title="
      disabled
        ? 'Este trámite no admite un pago desde esta cuenta'
        : group.tramite.taxPaidDate
        ? 'Ver comprobante de pago'
        : 'Registrar pago de impuestos'
    "
    @click="$emit('click')"
  >
    <span class="tax-button-content">
      <span class="tax-button-status">
        <v-icon small aria-hidden="true">{{
          group.tramite.taxPaidDate ? 'check_circle_outline' : 'schedule'
        }}</v-icon>
        {{
          group.tramite.taxPaidDate
            ? 'Pagado'
            : Number(group.tramite.taxAmount || 0) > 0
            ? 'Completar pago'
            : 'Sin pago ni monto'
        }}
      </span>
      <span v-if="group.tramite.taxAmount != null" class="tax-button-amount">{{
        amount
      }}</span>
    </span>
    <v-icon class="tax-button-action" small aria-hidden="true">{{
      group.tramite.taxPaidDate ? 'receipt' : 'chevron_right'
    }}</v-icon>
  </button>
</template>
<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    group: { type: Object, required: true },
    amount: { type: String, required: true },
  },
  computed: {
    state() {
      return this.group.tramite.taxPaidDate
        ? 'paid'
        : Number(this.group.tramite.taxAmount || 0) > 0
        ? 'pending'
        : 'customer'
    },
  },
}
</script>
<style scoped>
.tax-button:focus-visible {
  outline: 2px solid #254f87;
  outline-offset: 3px;
}
.tax-button {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 154px;
  min-height: 48px;
  padding: 9px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  text-align: left;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.tax-button-content {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.tax-button-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}
.tax-button-status .v-icon {
  color: inherit;
  font-size: 16px;
}
.tax-button-amount {
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  line-height: 18px;
  white-space: nowrap;
  padding-left: 22px;
}
.tax-button-action {
  color: #64748b;
}
.tax-button:disabled {
  cursor: default;
}
.tax-button:disabled .tax-button-action {
  display: none;
}
.tax-button--paid {
  background: #f0fdf4;
  border-color: #bbdfc8;
}
.tax-button--paid .tax-button-status {
  color: #166534;
}
.tax-button--paid .tax-button-action {
  color: #166534;
}
.tax-button--paid:hover {
  background: #dcfce7;
  border-color: #86b69a;
}
.tax-button--pending {
  background: #fff7ed;
  border-color: #fdba74;
}
.tax-button--pending .tax-button-status {
  color: #9a3412;
}
.tax-button--customer {
  background: #fef2f2;
  border-color: #fca5a5;
}
.tax-button--customer .tax-button-status {
  color: #991b1b;
}
.tax-button--pending:hover {
  background: #ffedd5;
  border-color: #fb923c;
}
.tax-button--customer:hover {
  background: #fee2e2;
  border-color: #f87171;
}
@media (prefers-reduced-motion: reduce) {
  .tax-button {
    transition: none;
  }
}
</style>
